import type { ComponentType } from 'react'
import type { ExploreCategory } from 'tripPlanner/pages/trip/Explore/common'
import type { ItemType } from 'tripPlanner/types/tripItem'

import SolidCameraPlusIcon from 'LuxKit/Icons/solid/SolidCameraPlusIcon'
import SolidRestaurantIcon from 'LuxKit/Icons/solid/SolidRestaurantIcon'
import SolidCoffeeIcon from 'LuxKit/Icons/solid/SolidCoffeeIcon'
import SolidTreesIcon from 'LuxKit/Icons/solid/SolidTreesIcon'
import SolidShoppingBagIcon from 'LuxKit/Icons/solid/SolidShoppingBagIcon'
import SolidUniversityIcon from 'LuxKit/Icons/solid/SolidUniversityIcon'
import SolidGlassMartiniAltIcon from 'LuxKit/Icons/solid/SolidGlassMartiniAltIcon'
import SolidFootballBallIcon from 'LuxKit/Icons/solid/SolidFootballBallIcon'
import SolidBedIcon from 'LuxKit/Icons/solid/SolidBedIcon'
import SolidTicketIcon from 'LuxKit/Icons/solid/SolidTicketIcon'
import SolidPlaneDepartureIcon from 'LuxKit/Icons/solid/SolidPlaneDepartureIcon'
import SolidCarIcon from 'LuxKit/Icons/solid/SolidCarIcon'
import LineNotesIcon from 'LuxKit/Icons/line/LineNotesIcon'
import type { SvgIconComponent } from 'LuxKit/SvgIcon'

export const itemPinCategories = [
  'Attraction',
  'Restaurants',
  'Cafes',
  'Parks',
  'Shopping',
  'Museums',
  'Bars',
  'Sports',
  'Hotels',
  'Experiences',
  'Flight',
  'Car',
  'Note',
] as const

export type ItemPinCategory = (typeof itemPinCategories)[number]

export const categoryIconMap: Record<ItemPinCategory, ComponentType> = {
  Attraction: SolidCameraPlusIcon,
  Restaurants: SolidRestaurantIcon,
  Cafes: SolidCoffeeIcon,
  Parks: SolidTreesIcon,
  Shopping: SolidShoppingBagIcon,
  Museums: SolidUniversityIcon,
  Bars: SolidGlassMartiniAltIcon,
  Sports: SolidFootballBallIcon,
  Hotels: SolidBedIcon,
  Experiences: SolidTicketIcon,
  Flight: SolidPlaneDepartureIcon,
  Car: SolidCarIcon,
  Note: LineNotesIcon,
}

const EXPLORE_LABEL_TO_PIN_CATEGORY: Record<ExploreCategory['label'], ItemPinCategory> = {
  'Top attractions': 'Attraction',
  'Restaurants': 'Restaurants',
  'Cafes': 'Cafes',
  'Parks': 'Parks',
  'Shopping': 'Shopping',
  'Museums': 'Museums',
  'Bars': 'Bars',
  'Sports': 'Sports',
}

const ITEM_TYPE_TO_PIN_CATEGORY: Record<ItemType, ItemPinCategory> = {
  ACCOMMODATION: 'Hotels',
  ATTRACTION: 'Attraction',
  RESTAURANT_BAR: 'Restaurants',
  EVENT: 'Attraction',
  THING_TO_DO: 'Attraction',
  EXPERIENCE: 'Experiences',
  TOUR: 'Experiences',
  CRUISE: 'Experiences',
  FLIGHT: 'Flight',
  CAR_RENTAL: 'Car',
  TRAIN: 'Car',
  FERRY: 'Car',
  BUS: 'Car',
  OTHER_TRANSPORT: 'Car',
  NOTE: 'Note',
}

export function getItemPinCategory(
  input: ExploreCategory['label'] | ItemType,
): ItemPinCategory {
  if (input in EXPLORE_LABEL_TO_PIN_CATEGORY) {
    return EXPLORE_LABEL_TO_PIN_CATEGORY[input as ExploreCategory['label']]
  }

  return ITEM_TYPE_TO_PIN_CATEGORY[input as ItemType] || 'Attraction'
}

export function getItemPinIcon(category: ItemPinCategory): SvgIconComponent {
  return categoryIconMap[category] || categoryIconMap.Attraction
}
